import React from "react";
import { BROADCAST_SEND_TYPE } from "../constants/broadcast";
import { SelectTagWidgetContainer } from "../../BroadcastView.styles";
import Button from "../../../../../components/shared/components/button/Button.style";
import { BroadcastAppCard, InfoBanner, InfoBannerText, SuccessActionsContainer, SuccessContainer, SuccessDetailCard, SuccessDetailLabel, SuccessDetailsGrid, SuccessDetailValue, SuccessIcon, SuccessSubtitle, SuccessTitle, WarningBanner, WarningText } from "../styles";


export const BroadcastSuccess = ({ broadcastData, handleReset }) => {
  const {
    // Campaign
    broadcastName,
    campaignCost,

    // Contacts
    contacts,

    // Schedule
    sendType,
    scheduledDate,
    scheduledTime,

    // Template
    templateId,
    templateName,
  } = broadcastData;

  const getScheduleText = () => {
    if (sendType === BROADCAST_SEND_TYPE.NOW) {
      return "Envío inmediato";
    }

    return `Programado para ${scheduledDate} a las ${scheduledTime}`;
  };

  return (
    <SelectTagWidgetContainer>
      <BroadcastAppCard>
        <SuccessContainer>
          <SuccessIcon />

          <div>
            <SuccessTitle>¡Campaña Programada Exitosamente!</SuccessTitle>

            <SuccessSubtitle>
              Tu campaña de difusión ha sido programada y está en proceso de
              envío
            </SuccessSubtitle>
          </div>

          <SuccessDetailsGrid>
            <SuccessDetailCard>
              <SuccessDetailLabel>Nombre de Campaña</SuccessDetailLabel>

              <SuccessDetailValue>{broadcastName}</SuccessDetailValue>
            </SuccessDetailCard>

            <SuccessDetailCard>
              <SuccessDetailLabel>Plantilla</SuccessDetailLabel>

              <SuccessDetailValue>{templateName}</SuccessDetailValue>
            </SuccessDetailCard>

            <SuccessDetailCard>
              <SuccessDetailLabel>Contactos Enviados</SuccessDetailLabel>

              <SuccessDetailValue>{contacts.length}</SuccessDetailValue>
            </SuccessDetailCard>

            <SuccessDetailCard>
              <SuccessDetailLabel>Costo Total</SuccessDetailLabel>

              <SuccessDetailValue>${campaignCost} USD</SuccessDetailValue>
            </SuccessDetailCard>
          </SuccessDetailsGrid>

          <InfoBanner>
            <InfoBannerText>
              <strong>{getScheduleText()}</strong> - Puedes revisar el estado de
              tu campaña en el panel de difusiones.
            </InfoBannerText>
          </InfoBanner>

          {!templateId && (
            <WarningBanner>
              <WarningText>
                La campaña se enviará una vez que Meta apruebe la plantilla.
              </WarningText>
            </WarningBanner>
          )}

          <SuccessActionsContainer>
            <Button designV4 onClick={handleReset}>
              Crear Nueva Campaña
            </Button>
          </SuccessActionsContainer>
        </SuccessContainer>
      </BroadcastAppCard>
    </SelectTagWidgetContainer>
  );
};
